var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://i.pinimg.com/originals/b7/fb/80/b7fb80122cf46d0e584f3a0768aef282.gif"}})
}
var staticRenderFns = []

export { render, staticRenderFns }